export const HARMONY_CALLBACK = "HARMONY_CALLBACK";
export const APTITUDE_CALLBACK = "APTITUDE_CALLBACK";
